import '../img/passport-style-photo-correct.jpg';
import '../img/passport-style-photo-incorrect.jpg';
import '../img/oip-logo.png';

import '../sass/main.scss';

import { initModals } from './common/modals';

import './common/custom-select.js';
import './common/focus.js';
import './common/css-variables.js';

import './layouts/cookies-notice.js';
import './layouts/site-header.js';
import './layouts/site-menu-modal.js';
import './layouts/site-menu-bar.js';
import './layouts/site-footer.js';
import './layouts/site-blocks.js';

import './common/on-screen.js';

(() => {
    initModals();
})();
